import { Box } from '@apia/theme';
import { CollectorField } from '../CollectorField';

export class CollectorSeparator extends CollectorField {
  private static maxId = 0;

  type = 'label';

  constructor() {
    super(`separator${CollectorSeparator.maxId++}`, '');
  }

  Component = () => {
    return <Box className="separator" />;
  };
}
